// Builds the message shown when the userGroup save response includes emails that
// don't belong to an existing user yet - they were sent a registration invite instead
// of being added to the group immediately.
export const getInvitedEmailsMessage = (invitedEmails: string[]): string => {
  const isPlural = invitedEmails.length > 1;
  return `Följande e-postadress${isPlural ? "er finns" : " finns"} inte i systemet ännu: ${invitedEmails.join(", ")}. En inbjudan att skapa konto har skickats - använd${isPlural ? "arna läggs" : "aren läggs"} till i gruppen automatiskt när registreringen är klar.`;
};
